import { useCallback } from 'react';

import { useGlobalKeyboardHandlerTogglers } from '../../contexts/global-keyboard-handler-togglers';
import { KeyboardKeysType } from '../../types/keyboard-keys';

export const useIsGlobalKeyboardHandlerTurnedOnChecker = () => {
    const globalKeyboardHandlerTogglers = useGlobalKeyboardHandlerTogglers();

    return useCallback(
        (key: string) => globalKeyboardHandlerTogglers[<KeyboardKeysType>key],
        [globalKeyboardHandlerTogglers]
    );
};
